import { Injectable, inject } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import {
  MessageThread,
  MessageThreadSortEnum,
} from "src/app/services/ui-helpers/_models/interfaces/messaging.interfaces";
import { MessagingService } from "../../../services/ui-helpers/messaging-services/messaging.service";
import { processHttpError } from "./process-http-error";

@Injectable({
  providedIn: "root",
})
export class MessagingStateService {
  private messagingService = inject(MessagingService);

  private newMessagesSubject = new BehaviorSubject<boolean>(false);
  public newMessages$ = this.newMessagesSubject.asObservable();

  private unreadCountSubject = new BehaviorSubject<number>(0);
  public unreadCount$ = this.unreadCountSubject.asObservable();

  async checkUnreadMessages(): Promise<void> {
    try {
      const data = await this.messagingService.getAllMessageThreads(
        { sortBy: MessageThreadSortEnum.OLD_ITEMS_LAST },
        1,
        100,
        false
      );

      if (data?.data) {
        const unreadMessages = data.data.filter(
          (thread: MessageThread) => thread.unreadCount > 0
        );
        const totalUnreadCount = data.data.reduce(
          (total: number, thread: MessageThread) => total + thread.unreadCount,
          0
        );

        this.newMessagesSubject.next(unreadMessages.length > 0);
        this.unreadCountSubject.next(totalUnreadCount);
      }
    } catch (error: unknown) {
      processHttpError(error);
    }
  }

  setNewMessages(hasNewMessages: boolean): void {
    this.newMessagesSubject.next(hasNewMessages);
  }

  setUnreadCount(count: number): void {
    this.unreadCountSubject.next(count);
  }

  getCurrentUnreadCount(): number {
    return this.unreadCountSubject.value;
  }
}
